export const headers = {
  _id: {
    name: "Orders",
    width: 1,
    color: "#2793de",
  },
};

export const mdHeaders = {
  _id: {
    name: "Orders",
    width: 1,
    color: "#2793de",
  },
};

export const smHeaders = {
  _id: {
    name: "Orders",
    width: 1,
    color: "#2793de",
  },
};

export const operationHeaders = {
  documentNumber: {
    name: "Document Number",
    width: 0.2,
  },
  customerName: {
    name: "Company Name",
    width: 0.6,
  },
  customerNumber: {
    name: "Customer Number",
    width: 0.4,
  },
  shippingMethod: {
    name: "Shipping Method",
    width: 0.4,
  },
  orderStatus: {
    name: "Status",
    width: 0.25,
    textAlign: "center",
    justifyContent: "center",
  },
  sapDocumentNumber: {
    name: "SAP Document No",
    width: 0.3,
  },
  orderDate: {
    name: "Order Date",
    width: 0.3,
  },
  deliveryDate: {
    name: "Delivery Date",
    width: 0.4,
  },
  actions: {
    name: "Actions",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
};

export const mdoperationHeaders = {
  documentNumber: {
    name: "Document Number",
    width: 0.2,
  },
  customerName: {
    name: "Company Name",
    width: 0.6,
  },
  orderStatus: {
    name: "Status",
    width: 0.25,
    textAlign: "center",
  },
  orderDate: {
    name: "Order Date",
    width: 0.3,
  },
  deliveryDate: {
    name: "Delivery Date",
    width: 0.4,
  },
  actions: {
    name: "Actions",
    width: 0.4,
    textAlign: "right",
  },
};

export const smoperationHeaders = {
  order: {
    name: "Order",
    width: 0.7,
  },
  orderStatus_sm: {
    name: "Status",
    width: 0.3,
    textAlign: "right",
  },
};
